import { Container, Grid, Typography, Box, Button, } from '@material-ui/core';
import React from 'react';
import "aos/dist/aos.css";
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

import EmailImg from "../../asset/images/email-icon.png"

export default function Pressreleases() {

    return (
        <>
            <Box className='sec_bg' component='section' pt={3} pb={1}>
                <Container maxWidth='lg' className='bdr'>
                    <Box className='sec_bg' component='section'>
                        <Container maxWidth='lg' className='bdr'>
                            <Grid container spacing={5} alignItems="center" justifyContent='center'>
                                <Grid item lg={6} md={6} sm={12} xs={12}>
                                    <Box className='whitebx '>
                                        <Grid container spacing={5} alignItems="top">
                                            <Grid item lg={3} md={4} sm={12} xs={12} className='fx_c'>
                                                <Box>
                                                    <img loading="lazy" src={EmailImg} alt='email img' />
                                                </Box>
                                            </Grid>

                                            <Grid item lg={9} md={8} sm={12} xs={12}>
                                                <Box>
                                                    <Typography variant='h2' className='blue mb0 mob_c'>
                                                        Media Contact
                                                    </Typography>

                                                    <Box mt={1}>
                                                        <Typography variant='h6' className='black mob_c mb0'>
                                                            Reach out to us for editorial collaborations and media inquiries.
                                                        </Typography>
                                                    </Box>

                                                    <Box my={1} className='mob_c'>
                                                        <Button
                                                            variant="contained"
                                                            className="dpabtn_sm2"
                                                            onClick={() => window.location.href = "mailto:sailaja.das@decimalpointanalytics.com"}
                                                        >
                                                            Contact our PR Team Here
                                                        </Button>

                                                    </Box>

                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Container>
                    </Box>
                </Container>
            </Box>
        </>
    );
}
